export const BASE_URL = 'https://test.apps.pmind.ro';
